// extracted by mini-css-extract-plugin
module.exports = {"caption":"Caption_caption__1p4cs","body":"Caption_body__39wfr","currentCaption":"Caption_currentCaption__M5Pk3","timestamp":"Caption_timestamp__1fBAM"};